import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    minHeight: 300,
    maxWidth: 340,
    minWidth: 340,
    borderRadius: 8,
    overflow: "hidden",
    shadowColor: "#000",
    shadowOffset: {
      width: 4,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4.84,
    elevation: 4,
  },
  overlay: {
    alignItems: "center",
    flex: 1,
    backgroundColor: "rgba(0, 0, 0, 0)",
    justifyContent: "flex-end",
    padding: 12,
    borderRadius: 8,
  },

  msgSalveAmazonia: {
    alignItems: "center",
    fontSize: 18,
    fontWeight: "bold",
    color: "#FFF",
    marginBottom: 40,
    textAlign: "center",
  },

  buttonContainer: {
    flexDirection: "row",
    marginBottom: 18,
  },

  btnAdotar: {
    paddingHorizontal: 40,
    flex: 1,
    height: 40,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
  },

  btnAdotarText: {
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: "500",
  },
});

export default styles;
